module.exports = __webpack_public_path__ + "img/no-snippet-dark.3e1d79d.svg";